module.exports = __webpack_public_path__ + "static/how-to-win-friends-3d5a1f21d00dc139fc57b9fceb266752.webp";